<script>
export default
{
    name: 'layout-single-column',

    mounted()
    {

    }
}
</script>

<template>
<main class="offer-page">
    <router-view>

    </router-view>
</main>
</template>



// WEBPACK FOOTER //
// src/layouts/SingleColumn.vue